import type { BankAccountProps } from '@api/models/bank-account';

const isBankAccountAvailableForFixingCompany = (
	bankAccount: Pick<BankAccountProps, 'vesselId' | 'fixingCompanyId'>,
	fixingCompanyId: number | null | undefined,
) => (
	bankAccount.fixingCompanyId == null ?
		bankAccount.vesselId != null :
		bankAccount.fixingCompanyId === fixingCompanyId
);

export default isBankAccountAvailableForFixingCompany;
